module.exports = __webpack_public_path__ + "img/PEDRO_GOMES.5d017a09.jpeg";